import { Builder } from '@builder.io/sdk';
import { ShareCTA, SHARE_CTA_COMPONENT_NAME } from './ShareCTA';

const ShareCTAConfig = {
  name: SHARE_CTA_COMPONENT_NAME,
  friendlyName: 'Share CTA',
  inputs: [
    {
      name: 'overline',
      type: 'string',
      friendlyName: 'Overline Text',
      helperText: 'Small text displayed above the heading in the primary/orange color',
      defaultValue: 'Found this useful?',
      required: false,
    },
    {
      name: 'heading',
      type: 'string',
      friendlyName: 'Heading',
      helperText: 'Main heading displayed in white on the purple background',
      defaultValue: 'Share Tempcover with a friend or save for later',
      required: false,
    },
  ],
};

Builder.registerComponent(ShareCTA, ShareCTAConfig);
